export type NoiseReductionProvider = "passthrough" | "browser" | "rnnoise";

export type NoiseReductionStatus = "idle" | "loading" | "active" | "fallback" | "unavailable" | "error";

export interface NoiseReductionProviderStateLike {
    provider: NoiseReductionProvider;
    status: NoiseReductionStatus;
}

export interface NoiseReductionAudioProcessingConstraints {
    autoGainControl: boolean;
    echoCancellation: boolean;
    noiseSuppression: boolean;
}

export function getAudioProcessingConstraints(
    provider: NoiseReductionProvider
): NoiseReductionAudioProcessingConstraints {
    switch (provider) {
        case "browser":
            return {
                autoGainControl: true,
                echoCancellation: true,
                noiseSuppression: true,
            };
        case "passthrough":
            return {
                autoGainControl: false,
                echoCancellation: false,
                noiseSuppression: false,
            };
        case "rnnoise":
            return {
                autoGainControl: false,
                echoCancellation: true,
                noiseSuppression: false,
            };
    }
}

export function getCaptureNoiseReductionProvider(
    state: NoiseReductionProviderStateLike
): NoiseReductionProvider {
    return state.status === "fallback" ? "browser" : state.provider;
}
